import { Link } from "react-router-dom";
import { type LinkItem } from "@/data/site";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/wensity/card";

export function ExternalLinkCard({ item }: { item: LinkItem }) {
  return (
    <a href={item.url} target="_blank" rel="noopener noreferrer" className="group block h-full">
      <Card className="h-full border-[var(--color-border)] bg-[rgba(20,24,22,0.72)] transition duration-300 group-hover:-translate-y-0.5 group-hover:border-[var(--color-primary-dim)]">
        <CardHeader>
          {item.category ? (
            <p className="text-xs uppercase tracking-[0.14em] text-[var(--color-muted)]">{item.category}</p>
          ) : null}
          <CardTitle className="flex items-center gap-2 text-lg text-[var(--color-foreground)]">
            {item.name}
            <span className="text-[var(--color-primary)] opacity-70 transition group-hover:opacity-100">↗</span>
          </CardTitle>
          <CardDescription>{item.description}</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="truncate font-mono text-xs text-[var(--color-muted)]">{item.url}</p>
        </CardContent>
      </Card>
    </a>
  );
}

export function LinkTile({ item }: { item: LinkItem }) {
  return (
    <a
      href={item.url}
      target="_blank"
      rel="noopener noreferrer"
      className="group block w-64 shrink-0 snap-start"
    >
      <Card className="h-full border-[var(--color-border)] bg-[rgba(20,24,22,0.72)] transition duration-300 group-hover:-translate-y-0.5 group-hover:border-[var(--color-primary-dim)]">
        <CardHeader className="gap-1.5 p-4">
          {item.category ? (
            <p className="text-[11px] uppercase tracking-[0.14em] text-[var(--color-muted)]">{item.category}</p>
          ) : null}
          <CardTitle className="flex items-center gap-1.5 text-sm text-[var(--color-foreground)]">
            {item.name}
            <span className="text-[var(--color-primary)] opacity-70 transition group-hover:opacity-100">↗</span>
          </CardTitle>
          <CardDescription className="text-xs">{item.description}</CardDescription>
        </CardHeader>
      </Card>
    </a>
  );
}

export function LinkTileRow({ items }: { items: LinkItem[] }) {
  return (
    <div className="-mx-4 flex snap-x snap-mandatory gap-4 overflow-x-auto px-4 pb-2 [scrollbar-width:none] sm:-mx-6 sm:px-6 [&::-webkit-scrollbar]:hidden">
      {items.map((item) => (
        <LinkTile key={item.url} item={item} />
      ))}
    </div>
  );
}

export function SectionHeader({ title, href, linkLabel }: { title: string; href?: string; linkLabel?: string }) {
  return (
    <div className="mb-6 flex items-end justify-between gap-4">
      <h2 className="text-xl font-semibold tracking-tight text-[var(--color-foreground)]">{title}</h2>
      {href && linkLabel ? (
        <Link to={href} className="text-sm text-[var(--color-primary)] hover:underline">
          {linkLabel}
        </Link>
      ) : null}
    </div>
  );
}
